import React, { useState, MouseEvent } from "react";
import { Box } from "@mui/system";
import DownloadIcon from "../../assets/common/downloadNewIcon.svg";
import { Tooltip, Popover, Typography, Divider } from "@mui/material";
import optionsDownloadIcon from "../../assets/action-items/attachments-downlaod.svg";
import "../../styles/common.css";

export interface ExportOption {
  label: string;
  value: string;
  onClick?: () => void;
}

interface DownloadReportProps {
  onDownload?: (type?: string) => void;
  disabled?: boolean;
  options?: ExportOption[];
}

const DownloadReport = ({ onDownload, disabled = false, options }: DownloadReportProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (disabled) return;
    if (options && options.length > 0) {
      setAnchorEl(event.currentTarget);
    } else if (onDownload) {
      onDownload();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option: ExportOption) => {
    handleClose();
    if (option.onClick) {
      option.onClick();
    } else if (onDownload) {
      onDownload(option.value);
    }
  };

  return (
    <>
      <Tooltip title="Export Visible Data" arrow placement="top">
        <Box className="download-icon">
          <Box
            className={`download-button ${disabled ? "disabled" : ""}`}
            onClick={handleClick}
          >
            <img src={DownloadIcon} alt="download" width={24} height={24} />
          </Box>
        </Box>
      </Tooltip>

      {options && options.length > 0 && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            className: "download-report-popover-paper",
          }}
        >
          <Box className="download-report-options-container">
            {options.map((option, index) => (
              <React.Fragment key={option.value}>
                {index > 0 && <Divider className="download-report-divider" />}
                <Box
                  className="download-report-option-item"
                  onClick={() => handleOptionClick(option)}
                >
                  <img src={optionsDownloadIcon} alt="download" />
                  <Typography className="download-report-option-text">
                    {option.label}
                  </Typography>
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </Popover>
      )}
    </>
  );
};

export default DownloadReport;